var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9168 6.50016C11.9168 9.49016 9.49016 11.9168 6.50016 11.9168C3.51016 11.9168 1.68475 8.90516 1.68475 8.90516M1.68475 8.90516H4.13308M1.68475 8.90516V11.6135M1.0835 6.50016C1.0835 3.51016 3.4885 1.0835 6.50016 1.0835C10.1131 1.0835 11.9168 4.09516 11.9168 4.09516M11.9168 4.09516V1.38683M11.9168 4.09516H9.51183",
    stroke: "#586370",
    strokeWidth: 0.8125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshOutline);
export default __webpack_public_path__ + "static/media/refresh-outline.2c7ceaca87170200bceaa48e9c99aa9a.svg";
export { ForwardRef as ReactComponent };